import { AxiosError } from 'axios'

import { api } from '../libs/axios'

export interface Product {
  id: string
  name: string
  code: string
  created_at: string
}

export interface GetProductsRequest {
  page?: number
  id?: string
  name?: string
  code?: string
}

interface GetProductsResponse {
  products: Product[]
  totalCount: number
  pageQty: number
}

export async function getProducts(
  searchParams: GetProductsRequest,
): Promise<GetProductsResponse> {
  try {
    const params: { [key: string]: string | boolean } = {}

    Object.entries(searchParams).forEach(([key, value]) => {
      const param = key.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
      params[param] = value
    })

    const result = await api.get<GetProductsResponse>('/products', {
      params,
    })

    const { data } = result

    return data
  } catch (err) {
    if (err instanceof AxiosError) {
      console.error(err.message)
    }
    return {
      products: [],
      pageQty: 0,
      totalCount: 0,
    }
  }
}

interface CreateProductRequest {
  name: string
  code?: string
}

interface CreateProductResponse {
  product: Product
}

export async function createProduct({
  name,
  code,
}: CreateProductRequest) {
  try {
    const { data } = await api.post<CreateProductResponse>('/products', {
      name,
      code,
    })

    return {
      product: data.product,
      success: true,
      message: 'Produto atualizado',
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      return {
        product: undefined,
        success: false,
        message: err.response?.data.message ?? 'Não foi possível atualizar o produto!',
      }
    }
  }
}

interface UpdateProductRequest {
  name?: string
  code?: string
  productId: string
}

interface UpdateProductResponse {
  product: Product
}

export async function updateProduct({
  name,
  code,
  productId,
}: UpdateProductRequest) {
  try {
    const { data } = await api.put<UpdateProductResponse>('/products', {
      name,
      code,
      productId,
    })

    return {
      product: data.product,
      success: true,
      message: 'Produto atualizado',
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      return {
        product: undefined,
        success: false,
        message: err.response?.data.message ?? 'Não foi possível atualizar o produto!',
      }
    }
  }
}

interface GetAllProductsResponse {
  products: {
    id: string
    name: string
  }[]
}

export async function getAllProducts() {
  try {
    const { data } = await api.get<GetAllProductsResponse>('/products/all')
    return data
  } catch (error) {
    if (error instanceof AxiosError && error.code === 'DUPLICATE_REQUEST') {
      console.log(error)
    }
    return {
      products: [],
    }
  }
}
